import { jsx as _jsx } from "react/jsx-runtime";
import { SearchItemStyles } from "./styles";
export var MenuSearchItem = function (_a) {
    var subsubitem = _a.subsubitem, parentPath = _a.parentPath, setModalItem = _a.setModalItem;
    var pathToGo = subsubitem.overridePath || parentPath + subsubitem.path;
    return (_jsx(SearchItemStyles, { id: "menu-item-".concat(subsubitem.id), to: pathToGo, onClick: function () { return setModalItem === null || setModalItem === void 0 ? void 0 : setModalItem(null); }, children: subsubitem.searchText }));
};
//# sourceMappingURL=index.js.map